import React from 'react';
import {
  IconButton,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  SxProps,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type MembershipConditionsDialogProps = {
  sx?: SxProps;
  open: boolean;
  onClose: () => void;
};

const MembershipConditionsDialog: React.FC<MembershipConditionsDialogProps> = ({
  sx,
  open,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ minWidth: '1500px', overflow: 'hidden', ...sx }}
    >
      <DialogTitle display="flex" flexDirection="column">
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', left: '8px' }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" sx={{ ml: 4, mt: 6, fontWeight: 'bold' }}>
          {t('membershipConditionDialog.membershipAgreement')}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t('membershipConditionDialog.membershipConditionsContentParties')}
        </Typography>

        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentPartiesContentA',
          )}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentPartiesContentB',
          )}
        </Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t('membershipConditionDialog.membershipConditionsContentTopic')}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentTopicContent',
          )}
        </Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiability',
          )}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent1',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent2',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent3',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent4',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent5',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent6',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent7',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent8',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent9',
          )}{' '}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent10',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent11',
          )}{' '}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent12',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent13',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent14',
          )}
          <br />
          <br />
          {t(
            'membershipConditionDialog.membershipConditionsContentRightAndLiabilityContent15',
          )}
        </Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentTermination',
          )}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentTerminationContent',
          )}
        </Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t('membershipConditionDialog.membershipConditionsContentDisputes')}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentDisputesContent',
          )}
        </Typography>
        <br />
        <Typography variant="h6" sx={{ textAlign: 'left' }}>
          {t('membershipConditionDialog.membershipConditionsContentForce')}
        </Typography>
        <br />
        <Typography sx={{ textAlign: 'left' }}>
          {t(
            'membershipConditionDialog.membershipConditionsContentForceContent',
          )}
        </Typography>
        <br />
      </DialogContent>
    </Dialog>
  );
};

export default MembershipConditionsDialog;
